import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area.tsx'

import { LoadingSpinner } from '@/components/LoadingSpinner.tsx'
import { useQueryProjectMembers, useQueryStoryHistory } from '@/requests/queries/useQueryProject.ts'
import { toReadableDateTime } from '@/utils/date.ts'

type Props = {
  story: Story
}

export const StoryHistory = ({ story }: Props) => {
  const { members } = useQueryProjectMembers()
  const { history, loading } = useQueryStoryHistory(story.id)

  const constructActivityDescription = (activity: ProjectActivity) => {
    const map = new Map(members.map((member) => [member.id, member]))
    const performedBy = map.get(activity.performedById)?.name

    const [action, ...rest] = activity.description.split(' ')
    const detail = rest.join(' ')

    const createdAt = toReadableDateTime(new Date(activity.createdAt).getTime())
    const [date] = createdAt.split(',')

    return (
      <div className="flex justify-between items-center gap-2">
        <p className="font-EN-KR-body2-regular text-contents-primary break-all">
          {performedBy} <span className="font-EN-KR-body2-bold">{action}</span> {detail}
        </p>

        <p className="font-EN-KR-body2-regular text-contents-secondary flex-shrink-0">{date}</p>
      </div>
    )
  }

  return (
    <ScrollArea>
      <div className="max-h-[calc(100vh-196px)] h-[calc(100vh-196px)]">
        {loading && <LoadingSpinner className="flex h-full items-center justify-center" />}
        {!loading &&
          (history.length === 0 ? (
            <div className="flex h-full flex-col justify-center items-center">
              <p className="font-EN-KR-body1-regular text-contents-tertiary">
                Story history is not displayed for migrated user stories.
              </p>
            </div>
          ) : (
            history.map((activity) => (
              <li key={activity.id} className="py-1 px-2 list-none">
                {constructActivityDescription(activity)}
              </li>
            ))
          ))}
      </div>

      <ScrollBar orientation="vertical" />
    </ScrollArea>
  )
}
